/**
 * Establecer un valor para la variable sales.
 */
export function setSales(state, sales) {
    state.sales = sales;
}

/**
 * Establecer un valor para la variable loading.
 */
export function setLoading(state, loading) {
    state.loading = loading;
}



// WEBPACK FOOTER //
// ./src/reports-aggrid/modules/sales_budget_by_contacts_warehouses/mutations.js